"use client";

import { LogOut } from "lucide-react";
import { AppButton } from "@/components/app/AppButton";
import { AppDialog } from "@/components/app/AppDialog";
import { Typography } from "@/components/app/Typography";
import { LogoutIcon } from "@/app/icons/customIcons";

interface LogoutDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm?: () => void;
}

export function LogoutDialog({ open, onOpenChange, onConfirm }: LogoutDialogProps) {
  const footer = (
    <div className="grid grid-cols-2 gap-3">
      <AppButton color="secondary" size="xl" fullWidth onClick={() => onOpenChange(false)}>
        Cancel
      </AppButton>
      <AppButton color="primary" size="xl" fullWidth onClick={() => { onConfirm?.(); onOpenChange(false); }}>
        Log Out
      </AppButton>
    </div>
  );

  return (
    <AppDialog open={open} onOpenChange={onOpenChange} size="md" title="Log Out?" footer={footer}>
      <div className="flex flex-col items-center gap-6 text-center py-4">
        <div
          className="w-44 h-44 rounded-full flex items-center justify-center"
          style={{ background: "url(/images/gradient-circle.svg) center / 100% no-repeat" }}
        >
          <LogoutIcon />
        </div>

        <div className="space-y-2 px-4">
          <Typography variant="h3" color="primary" className="font-bold">
            Are you sure you want to log out of your account?
          </Typography>
          <Typography variant="body2" color="muted">
            You will need to sign in again to access the dashboard.
          </Typography>
        </div>
      </div>
    </AppDialog>
  );
}
